module.exports = __webpack_public_path__ + "static/media/vuewin.fe2420e5.jpg";